import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ThemeModeService } from './_metronic/partials/layout/theme-mode-switcher/theme-mode.service';
import { RouteHistoryService } from './shared/services/route-history.service';

@Component({
  selector: 'body[root]',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  // Injected here so URL history tracking starts as early as possible.
  constructor(private modeService: ThemeModeService, private routeHistoryService: RouteHistoryService) { }
  
  ngOnInit() {
    this.modeService.init();
  }

}
